/** The Legal process (tracker · calendar · audit matrix · handler report · designer · /legal/case/:id) runs on the UK desk only —
 *  Australian legal is handled externally (Australia → Legal Notices / Legal Inbox). Pinning the collections region to UK stops the
 *  region switcher mixing an empty AU tracker with UK rows (and "Case not found" when a UK file is opened under region=AUS). */
import { Scale } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRegion } from "@/contexts/RegionContext";
import { setCollectionsRegion } from "@/lib/regionFmt";

export function useLegalDesk() {
  const { currentRegion, switchRegion } = useRegion();
  setCollectionsRegion("UK");
  return { pinned: currentRegion === "AUS", switchRegion };
}

export function LegalDeskBanner({ className = "" }) {
  const { pinned, switchRegion } = useLegalDesk();
  if (!pinned) return null;
  return (
    <div className={`flex flex-wrap items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900 ${className}`} data-testid="legal-desk-banner">
      <Scale className="w-3.5 h-3.5 shrink-0" />
      <span className="min-w-0">
        Legal runs on the <b>UK desk</b> — these are United Kingdom files, even though the region switcher says Australia.
        Australian legal is handled externally (Australia → Legal Notices / Legal Inbox).
      </span>
      <Button size="sm" variant="outline" className="h-7 text-xs ml-auto bg-white" onClick={() => switchRegion("UK")} data-testid="legal-desk-switch-uk">
        Switch to United Kingdom
      </Button>
    </div>
  );
}
